export const GOAL_KEY_POINTS = {
  careerGoal: {
    text: 'Career goal',
    icon: 'career'
  },
  academicGoal: {
    text: 'Academic goal',
    icon: 'academic'
  },
  compatibility: {
    text: 'Compatibility',
    icon: 'compatibility'
  },
  experience: {
    text: 'Experience',
    icon: 'experience'
  },
  decisionProcess: {
    text: 'Decision Process',
    icon: 'decision'
  },
  interests: {
    text: 'Interests',
    icon: 'interest'
  },
  values: {
    text: 'Values',
    icon: 'goal-values'
  },
  lifestylePreferences: {
    text: 'Lifestyle Preferences',
    icon: 'lifestyle-preferences'
  },
  motivations: {
    text: 'Motivations',
    icon: 'motivations'
  },
  currentStage: {
    text: 'Current Stage',
    icon: 'current-stage'
  },
  location: {
    text: 'Location',
    icon: 'location'
  },
  funding: {
    text: 'Funding',
    icon: 'funding'
  },
  supports: {
    text: 'Supports',
    icon: 'supports'
  },
  constraints: {
    text: 'Constraints',
    icon: 'constraints'
  }
} as const satisfies Record<string, GoalKeyPointInsight>;

export const VIA_GEN_STATUS = {
  queued: 'queued',
  inProgress: 'in-progress',
  partial: 'partial',
  completed: 'completed',
  /**
   * V-2. TERMINAL. The backend has reached this state since ACE.6 --
   * InsightReportStatus.FAILED, written by markReportFailed and streamed to the
   * browser as the last SSE frame -- and the frontend's type did not contain
   * the value at all.
   *
   * With an unknown status every render condition evaluated false, so the
   * panel drew literally nothing: no skeleton, no content, no overlay, under a
   * live "Insights from Via" header. Measured on dev: 4 reports sitting failed
   * against 446 completed.
   */
  failed: 'failed'
} as const satisfies Record<string, ViaReportStatus>;

export const VIA_TABS = {
  keyPoints: 0,
  topic: 1
} as const satisfies Record<string, number>;

export type ViaReportStatus =
  | 'queued'
  | 'in-progress'
  | 'partial'
  | 'completed'
  // V-2. Terminal, and NOT in REQUEUEABLE_REPORT_STATUSES, so nothing sweeps
  // it back. Only an explicit retry moves a report out of it.
  | 'failed';

export type GoalKeyPointInsight = { text: string; icon: string };

export type GoalInsightKeys = keyof typeof GOAL_KEY_POINTS;

export const GoalsOperation = [
  'goalsReportDetails',
  'GetGoals',
  'GetAiDeepInsight',
  'GenAiGoalsReport',
  'UserReclassifying'
] satisfies string[];
